import { Navigate, useLocation, useSearchParams } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation()
  const [searchParams] = useSearchParams()

  // Check for token in localStorage OR in URL (OAuth callback)
  const token = localStorage.getItem('auth_token')
  const urlToken = searchParams.get('token')

  if (!token && !urlToken) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/ops-portal/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
